import { render, staticRenderFns } from "./DownloadKeuringsOpmerkingen.vue?vue&type=template&id=fa2f538a"
import script from "./DownloadKeuringsOpmerkingen.vue?vue&type=script&lang=js"
export * from "./DownloadKeuringsOpmerkingen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports